<template>
  <div class="login">
    <div class="bg-div">
      <img class="bg_logo" src="../../static/images/bg_logo@3x.png">
      <img class="back-img" @click="backClick()" src="../../static/images/icon_back_w@3x.png">
      <div class="login-div">
        <span class="login-title">一键登录</span>
        <div class="login-btn" @click="loginClick()">
          <img src="../../static/images/icon_weixin@3x.png">
          <span>点击微信授权登录</span>
        </div>
      </div>
    </div>
<!--    <div class="protocol-div">-->
<!--      <span style="margin-left: 1.5rem;">登录即表示您同意</span>-->
<!--      <a @click="pushPage(0)" href="javascript:void(0);">用户协议</a>-->
<!--      <span>·</span>-->
<!--      <a @click="pushPage(1)" style="margin-left: 0;" href="javascript:void(0);">隐私协议</a>-->
<!--    </div>-->

  </div>
</template>

<script>
  export default {
    name: 'Login',
    data () {
      return {
        page:'',
        from:'',
        scode:'',
      }
    },

    mounted(){
      if (this.$route.query.from) {
        this.page = this.$route.query.page
        this.from = this.$route.query.from
        if (this.$route.query.scode) {
          this.scode = this.$route.query.scode
        }

      }
    },

    methods:{
      backClick(){
        this.$router.go(-1)
      },

      loginClick(){
        var json = {
          page:"home",
          from:"cmlink",
        }
        if (this.page.length > 0) {
          json.page = this.page
          json.from = this.from
          json.scode = this.scode
        }
        var str = this.$api.encrypt(json);

        this.$api.locationChange('common/wxLogin?state='+ str);
      },

      // pushPage(val){
      //   if (val == 0) {
      //     // this.$router.push({name:'userProtocol'})
      //     window.location = window.location.origin + '/cmlink/#/privacy'
      //   } else {
      //     // this.$router.push({name:'privacy'})
      //     window.location = window.location.origin + '/cmlink/#/privacy'
      //   }
      // },
    }
  }
</script>


<style scoped>
  .bg-div{
    position: relative;
    width: 100%;
    height: 7.2rem;
    background-color: #0F4172;
  }
  .login-div{
    position: absolute;
    top: 6.24rem;
    left: 0.5rem;
    width: 6.5rem;
    height: 3.58rem;
    background-color: #FFFFFF;
    box-shadow:0px 0.04rem 0.24rem 0px rgba(0,17,34,0.1);
    border-radius:0.12rem;
  }
  .bg_logo{
    position: absolute;
    left: 0rem;
    top: 0rem;
    width: 100%;
    height: 7.2rem;
  }
  .login-title{
    display: block;
    margin-top: 0.6rem;
    width: 6.5rem;
    font-size:0.38rem;
    /*font-family:NotoSansHans-Regular,NotoSansHans;*/
    font-weight:400;
    color:rgba(0,17,34,1);
    line-height:0.38rem;
    text-align: center;
  }
  .login-btn{
    margin: 0.6rem 0.78rem;
    width: 4.94rem;
    height: 1.1rem;
    background:rgba(254,166,4,1);
    border-radius:0.08rem;
  }
  .login-btn img{
    float: left;
    margin: .24rem 0 0 .72rem;
    width: 0.62rem;
    height: 0.62rem;
  }
  .login-btn span{
    float: left;
    margin-left: 0.16rem;
    font-size:0.34rem;
    /*font-family:NotoSansHans-Regular,NotoSansHans;*/
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:1.1rem;
  }
  .protocol-div{
    margin-top: 3.12rem;
    width: 100%;
    height: 0.26rem;
  }
  .protocol-div span{
    float: left;
    font-size:0.26rem;
    /*font-family:NotoSansHans-Light,NotoSansHans;*/
    font-weight:300;
    color:rgba(0,17,34,1);
    line-height:0.26rem;
  }
  .protocol-div a{
    float: left;
    margin-left: 0.2rem;
    font-size:0.26rem;
    /*font-family:NotoSansHans-Light,NotoSansHans;*/
    font-weight:300;
    color:rgba(15,65,114,1);
    line-height:0.26rem;
    text-decoration:underline;
  }

</style>



// WEBPACK FOOTER //
// src/components/Login.vue